export const localhostTenant = 'mounier';
